const config = {
    env: process.env.REACT_APP_ENV,
    baseURL: process.env.REACT_APP_BASE_URL,
};

export default config;